import { DifferentiationProps } from '@zola/zola-ui/src/components/PreAuthV3/Differentiation';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import { COLORS3 as COLORS } from '@zola/zola-ui/src/styles/emotion';

// Foreground Images
import AddressingMobile from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/addressing_mobile.png';
import AddressingDesktop from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/addressing_desktop.png';
import MessagingMobile from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/messaging_mobile.png';
import MessagingTablet from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/messaging_tablet.png';
import MessagingDesktop from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/messaging_desktop.png';
import SeatingMobile from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/seating_mobile.png';
import SeatingDesktop from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/seating_desktop.png';
import TrackingMobile from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/tracking_mobile.png';
import TrackingDesktop from '../../../../../public/static-preauth/images/GuestListLP/Differentiation/tracking_desktop.png';

export const differentiationContent: DifferentiationProps['content'] = [
  {
    id: 'tracking',
    subtitle: 'One place to keep track of everything',
    description:
      'Forget the confusing spreadsheets, manage all of the details from one simple platform.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.FOREST_100,
        },
      },
      foregroundImage: {
        desktopSrc: TrackingDesktop,
        tabletSrc: TrackingMobile,
        mobileSrc: TrackingMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'addressing',
    subtitle: 'Free guest addressing',
    description:
      'We’ll not only save your guests contact info, we’ll address your envelopes for free.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.BAY_100,
        },
      },
      foregroundImage: {
        desktopSrc: AddressingDesktop,
        tabletSrc: AddressingMobile,
        mobileSrc: AddressingMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'seating',
    subtitle: 'Seating chart builder',
    description:
      'Once you’ve added your guests, we’ll help you create a seating chart. And if you need place cards… yep, we do that too.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.WINE_100,
        },
      },
      foregroundImage: {
        desktopSrc: SeatingDesktop,
        tabletSrc: SeatingMobile,
        mobileSrc: SeatingMobile,
        imgType: 'png',
      },
    },
  },
  {
    id: 'messaging',
    subtitle: 'Get in touch with guests via group messaging',
    description:
      'Updated your wedding day schedule or want to give a heads up about bringing an umbrella? Send a quick message, your way.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.ROSE_100,
        },
      },
      foregroundImage: {
        desktopSrc: MessagingDesktop,
        tabletSrc: MessagingTablet,
        mobileSrc: MessagingMobile,
        imgType: 'png',
      },
    },
  },
];
